import { Button, Checkbox, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField } from '@material-ui/core';
import axios from 'axios';
import { withSnackbar } from 'notistack';
import React, { Component } from 'react';
import { handlePost } from '../../../utils/AxiosUtil';
import { NumberCell, NumberInput, DateTimeCell, DateCell } from '../../../utils/Cells';
import * as util from '../../../utils/Util';
import * as enums from '../../../utils/EnumMapping';

class ManualMatcherForPayable extends Component {
    state = {
        transactions: [],
        proposedTransactions: [],
        checkedItems: new Map(),
        billtype: '',
        checked: [],
        selected: [],
        selectedItems: new Map(),
        hasError: false,
        payable: {
            name: '',
            id: '',
            paymentDeadline: '',
            amount: null
        }
    };

    handleSuccess = (res) => {
        console.log(this.props);
        this.props.refresh();
        this.props.close();
    }

    componentDidMount() {
        console.log(this.props);
        this.setState({ billtype: this.props.billtype })
        const payable = this.getPayable();
        console.log(payable);
        this.setState({ payable: payable })
        this.callExpandApi()
            .then(res => this.setState({ transactions: res.data.transactions, proposedTransactions: res.data.proposedTransactions }))
            .catch(err => console.log(err));
    }

    getPayable = () => {
        switch (this.props.row.rowType) {
            case 'SALARY':
                return {
                    name: this.props.row.employeeName,
                    id: this.props.row.year + "." + this.props.row.month + " fizetés",
                    paymentDeadline: this.props.row.paymentDeadline,
                    amount: this.props.row.netSalary
                }
            case 'TAX':
                return {
                    name: this.props.row.taxTypeName,
                    id: this.props.row.publicId,
                    paymentDeadline: this.props.row.paymentDeadline,
                    amount: this.props.row.amount
                }
            case 'INCOMING_BILL':
                return {
                    name: this.props.row.customerName,
                    id: this.props.row.publicId,
                    paymentDeadline: this.props.row.paymentDeadline,
                    amount: this.props.row.amount
                }
            case 'OUTGOING_BILL':
                return {
                    name: this.props.row.customerName,
                    id: this.props.row.publicId,
                    paymentDeadline: this.props.row.paymentDeadline,
                    amount: this.props.row.amount
                }
            case 'RESTRAIN':
                return {
                    name: this.props.row.restrainPartnerName,
                    id: this.props.row.employeeName + " letiltás",
                    paymentDeadline: this.props.row.paymentDeadline,
                    amount: this.props.row.amount
                }
            case 'DIVIDEND':
                return {
                    name: this.props.row.employeeName,
                    id: "osztalék",
                    paymentDeadline: this.props.row.date,
                    amount: this.props.row.netAmount
                }
            default: return null;
        }
    }

    callExpandApi = async () => {
        const path = '/api/manualtransactions';
        const requestObject = {
            "privateId": this.props.row.privateId,
            "type": this.props.row.rowType,
        };
        const response = await axios.post(path, requestObject);
        if (response.status !== 200) throw Error(response.message);
        console.log(response);
        return response;
    };

    handleSubmit = async (event) => {
        event.persist()
        event.preventDefault();
        let request = {
            payableId: this.props.row.privateId,
            type: this.props.row.rowType,
            linkers: []
        };
        console.log(this.state.selectedItems)
        this.state.selectedItems.forEach((value, key, map) => {
            console.log(value)
            if (value && value.checked) {
                request.linkers.push({
                    "transactionId": key,
                    "amount": util.trimSpaces(value.amount)
                })
            }
        });

        console.log(request);
        const path = '/api/manuallink';
        handlePost(path, request, this);
    }

    getSumAmount = () => {
        let sum = 0;
        this.state.transactions.map((row) => (sum = sum + row.amount));
        /* eslint-disable array-callback-return */
        this.state.proposedTransactions.map((row) => {
            if (this.isSelected(row.privateId)) {
                sum = sum + parseInt(util.trimSpaces(this.state.selectedItems.get(row.privateId).amount));
            }
        })
        return sum;
    }

    getLinkedAmount = () => {
        let sum = 0;
        this.state.transactions.map((row) => (sum = sum + row.amount));
        this.state.proposedTransactions.map((row) => {
            if (this.isSelected(row.privateId)) {
                sum = sum + parseInt(util.trimSpaces(this.state.selectedItems.get(row.privateId).amount));
            }
        })
        return sum;
    }

    handleSelectAllClick = (event) => {
        if (event.target.checked) {
            const newSelecteds = this.state.proposedTransactions.map((n) => n.privateId);
            this.setState({ selected: newSelecteds });
            return;
        }
        this.setState({ selected: [] });
    };

    handleClick = (event, privateId, amountValue) => {
        console.log(this.state.proposedTransactions);
        console.log(privateId);
        const selectedIndex = this.state.selected.indexOf(privateId);
        let newSelected = [];
        let isChecked = true;
        if (selectedIndex === -1) {
            newSelected = newSelected.concat(this.state.selected, privateId);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(this.state.selected.slice(1));
            isChecked = false;
        } else if (selectedIndex === this.state.selected.length - 1) {
            newSelected = newSelected.concat(this.state.selected.slice(0, -1));
        } else if (selectedIndex > 0) {
            isChecked = false;
            newSelected = newSelected.concat(
                this.state.selected.slice(0, selectedIndex),
                this.state.selected.slice(selectedIndex + 1),
            );
        }
        this.setState({ selected: newSelected });
        const sumAmount = this.getSumAmount();
        const amount = this.state.payable.amount - sumAmount < amountValue ? this.state.payable.amount - sumAmount : amountValue;
        console.log(amount);
        const pair = {
            checked: isChecked,
            amount: amount
        }
        this.setState(prevState => ({ selectedItems: prevState.selectedItems.set(privateId, pair) }));
    };

    handleAmountChangeEvent = (event, privateId, remainingAmount) => {
        const pair = {
            checked: this.state.selectedItems.get(privateId).checked,
            amount: event.target.value,
        }
        this.setState(prevState => ({ selectedItems: prevState.selectedItems.set(privateId, pair) }));
    }

    getAmountFor = (privateId) => {
        const item = this.state.selectedItems.get(privateId);
        if (item) {
            if (item.amount > this.state.payable.amount) {

                if (this.getSumAmount() > this.state.payable.amount) {
                    return this.state.payable.amount - this.getSumAmount();
                } else {
                    return this.state.payable.amount;
                }
            } else {
                return item.amount;
            }
        } else {
            return 0;
        }
    }

    getErrorFor = (row) => {
        const item = this.state.selectedItems.get(row.privateId);
        /* eslint-disable no-mixed-operators */
        if (item && (parseInt(util.trimSpaces(item.amount)) > row.remainingAmount
            || parseInt(util.trimSpaces(item.amount)) > this.state.payable.amount)
            || item.amount === 0 || item.amount === '0') {
            return true;
        } else {
            return false;
        }
    }

    getErrorForTotal = () => {
        if (this.getSumAmount() > this.props.row.amount) {
            if (!this.state.hasError) {
                this.setState({ hasError: true });
            }
            return "custom-error";
        } else {
            if (this.state.hasError) {
                this.setState({ hasError: false });
            }
            return "";
        }
    }

    hasError = () => {
        let error = false;
        const totalError = this.getErrorForTotal();
        this.state.proposedTransactions.map((row) => {
            if (this.isSelected(row.privateId)) {
                error = error || this.getErrorFor(row);
            }
        });
        return error || totalError;
    }

    isSelected = (privateId) => this.state.selected.indexOf(privateId) !== -1;

    render() {
        return (
            <form onSubmit={this.handleSubmit}>
                <h3>{enums.getLabel(enums.objectTypes, this.props.row.rowType)}:</h3>
                <TableContainer component={Paper}>
                    <Table size="small" aria-label="a dense table">
                        <TableHead>
                            <TableRow key="header">
                                <TableCell>Megnevezés</TableCell>
                                <TableCell>Megjegyzés</TableCell>
                                <TableCell>Fizetési határidő</TableCell>
                                <TableCell align="right">Összeg</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            <TableRow key="new">
                                <TableCell> {this.state.payable.name}</TableCell>
                                <TableCell>{this.state.payable.id}</TableCell>
                                <TableCell> <DateCell value={this.state.payable.paymentDeadline} /></TableCell>
                                <TableCell align="right"><NumberCell value={this.state.payable.amount} /></TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </TableContainer>

                <h3>Linkelt tranzakciók:</h3>
                <TableContainer component={Paper}>
                    <Table size="small" aria-label="a dense table">
                        <TableHead>
                            <TableRow key="header">
                                <TableCell>Dátum</TableCell>
                                <TableCell>Ellenoldal</TableCell>
                                <TableCell>Megjegyzés</TableCell>
                                <TableCell align="right">Linkelt összeg</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {this.state.transactions.map((row) => (
                                <TableRow key={row.privateId}>
                                    <TableCell> <DateTimeCell value={row.transaction.transactionDateTime} /></TableCell>
                                    <TableCell> {row.transaction.contraName}</TableCell>
                                    <TableCell>{row.transaction.comment}</TableCell>
                                    <TableCell align="right"><NumberCell value={row.amount} /></TableCell>
                                </TableRow>
                            ))}
                            {
                                /* eslint-disable array-callback-return */
                                this.state.proposedTransactions.map((row) => {
                                    if (this.isSelected(row.privateId)) {
                                        return (
                                            <TableRow key={row.privateId} className="newly-added">
                                                <TableCell> <DateTimeCell value={row.transactionDateTime} /></TableCell>
                                                <TableCell> {row.contraName}</TableCell>
                                                <TableCell>{row.comment}</TableCell>
                                                <TableCell align="right">
                                                    <TextField
                                                        required
                                                        id={row.privateId}
                                                        name={row.privateId}
                                                        // label="Összeg"
                                                        pattern="[0-9]*"
                                                        value={this.getAmountFor(row.privateId)}
                                                        error={this.getErrorFor(row)}
                                                        onChange={e => this.handleAmountChangeEvent(e, row.privateId, row.remainingAmount)}
                                                        inputProps={{ style: { textAlign: 'right' } }}
                                                        InputProps={{ inputComponent: NumberInput, 'aria-label': 'naked' }}
                                                    />
                                                </TableCell>
                                            </TableRow>
                                        )
                                    }
                                })}
                            <TableRow key="total">
                                <TableCell> {"Összesen"}</TableCell>
                                <TableCell></TableCell>
                                <TableCell></TableCell>
                                <TableCell align="right" className={this.getErrorForTotal()}><NumberCell value={this.getSumAmount()} /></TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </TableContainer>
                <h3>Javasolt tranzakciók:</h3>
                <div className='scrollable-table'>
                    <TableContainer component={Paper}>
                        <Table size="small" aria-label="a dense table">
                            <TableHead>
                                <TableRow key="header">
                                    <TableCell padding="checkbox">
                                        <Checkbox
                                            indeterminate={this.state.selected.length > 0 && this.state.selected.length < this.state.proposedTransactions.length}
                                            checked={this.state.proposedTransactions.length > 0 && this.state.selected.length === this.state.proposedTransactions.length}
                                            onChange={this.handleSelectAllClick}
                                            inputProps={{ 'aria-label': 'select all desserts' }}
                                            color="primary"
                                        />
                                    </TableCell>
                                    <TableCell>Dátum</TableCell>
                                    <TableCell>Ellenoldal</TableCell>
                                    <TableCell>Megjegyzés</TableCell>
                                    <TableCell align="right">Összeg</TableCell>
                                    <TableCell align="right">Fennmaradó összeg</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {this.state.proposedTransactions.map((row, index) => {
                                    const isItemSelected = this.isSelected(row.privateId);
                                    const labelId = `enhanced-table-checkbox-${index}`;
                                    return (
                                        <TableRow
                                            key={row.privateId}
                                            hover
                                            onClick={(event) => this.handleClick(event, row.privateId, row.remainingAmount)}
                                            role="checkbox"
                                            aria-checked={isItemSelected}
                                            tabIndex={-1}
                                            selected={isItemSelected}
                                        >
                                            <TableCell padding="checkbox">
                                                <Checkbox
                                                    checked={isItemSelected}
                                                    inputProps={{ 'aria-labelledby': labelId }}
                                                    color="primary"
                                                />
                                            </TableCell>
                                            <TableCell> <DateTimeCell value={row.transactionDateTime} /></TableCell>
                                            <TableCell> {row.contraName}</TableCell>
                                            <TableCell>{row.comment}</TableCell>
                                            <TableCell align="right"><NumberCell value={row.amount} /></TableCell>
                                            <TableCell align="right"><NumberCell value={row.remainingAmount} /></TableCell>
                                        </TableRow>
                                    )
                                })}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </div>
                <div className="form-actions">
                    <Button className="btn-submit" variant="contained" color="primary" onClick={this.handleSuccess}>
                        Mégse
                    </Button>
                    <Button className="btn-submit" variant="contained" color="primary" type="submit" disabled={this.hasError()}>
                        Hozzáadás
                    </Button>
                </div>
            </form>
        )
    };
}

export default withSnackbar(ManualMatcherForPayable);